import * as THREE from 'three';

export type ModelInModelTreeInProcessEditor = {
    uuid: string;
    name: string;
    visible: boolean;
    isPartOfAModel: boolean;
    position: THREE.Vector3Tuple;
    rotation: THREE.EulerTuple;
    scale: THREE.Vector3Tuple;
    originalMaterial?: THREE.Material;
    children: ModelInModelTreeInProcessEditor[];
};

/**
 * 
 * @param models THREE.Object3D[]
 * @returns ModelInModelTreeInProcessEditor[]
 */
export const createModelTreeForPorcessEditorAndSetUUID = (models: THREE.Object3D[]): ModelInModelTreeInProcessEditor[] => {
    return models.map(model => {
        let uuid = model.userData?.uuid;
        if (!uuid) {
            uuid = THREE.MathUtils.generateUUID();
            model.userData = { ...model.userData, uuid };
        }

        model.uuid = uuid;

        return {
            uuid,
            name: model.name,
            isPartOfAModel: true,
            visible: model.visible,
            position: [model.position.x, model.position.y, model.position.z],
            rotation: [model.rotation.x, model.rotation.y, model.rotation.z],
            scale: [model.scale.x, model.scale.y, model.scale.z],
            originalMaterial: model.material ?? undefined,
            children: createModelTreeForPorcessEditorAndSetUUID(model.children)
        };
    });
};